import React from 'react'
import styled from 'styled-components'

import STYLE_CONSTANTS from '~/style/constants'
import { FETCHER_TIMEOUT_DURATIONS } from '~/utilities/constants'

const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-bottom: 1rem;
`

const TextContainer = styled.div`
  width: 100%;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  margin-left: 1.8rem;
  margin-top: 0.7rem;
  text-align: center;
`

const Title = styled.div`
  color: ${props => props.theme.colors.primary};
  font-size: 1rem;
  transition: all 0.5s ease;
`

const Description = styled.div`
  margin-top: 0.625rem;
  color: ${STYLE_CONSTANTS.colors.text.buttonGray};
  font-size: 0.875rem;
`

const ListItem = ({fetcher}) => {
  const itemStr = (fetcher === "NY_CRIMINAL") ? 'charges' : 'tickets';
  const name = `We're Searching for your ${itemStr}`

  // Convert lookup duration to minutes if it's over 60 seconds:
  const durationSeconds = (FETCHER_TIMEOUT_DURATIONS.traffic[fetcher] || FETCHER_TIMEOUT_DURATIONS.traffic.DEFAULT) / 1000
  let displayUnits = "seconds"
  let durationMinutes = 0
  let duration = durationSeconds

  if (durationSeconds > 60) {
    displayUnits = "minutes"
    durationMinutes = Math.floor(durationSeconds / 60)
    if (durationMinutes === 1) displayUnits = "minute"
    duration = durationMinutes
  }

  const description = `Please be patient as your search may take up to ${duration} ${displayUnits} to complete.`

  return (
    <ItemContainer>
      <TextContainer>
        <Title>{name}</Title>
        <Description>{description}</Description>
      </TextContainer>
    </ItemContainer>
  )
}


export default ListItem
